export class DeferredPromise<T> {
  promise: Promise<T>;
  private reject!: (reason?: any) => void;
  resolve!: (value: T) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
}
